import { render, staticRenderFns } from "./EfsMdGroupPriceListModal.vue?vue&type=template&id=2a54b0a0&"
import script from "./EfsMdGroupPriceListModal.vue?vue&type=script&lang=js&"
export * from "./EfsMdGroupPriceListModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports